/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thisisacluborassociation5Inputs */

const en_thisisacluborassociation5 = /** @type {(inputs: Thisisacluborassociation5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is a club or association`)
};

const de_thisisacluborassociation5 = /** @type {(inputs: Thisisacluborassociation5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies ist ein Verein`)
};

/**
* | output |
* | --- |
* | "This is a club or association" |
*
* @param {Thisisacluborassociation5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const thisisacluborassociation5 = /** @type {((inputs?: Thisisacluborassociation5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thisisacluborassociation5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thisisacluborassociation5(inputs)
	return de_thisisacluborassociation5(inputs)
});
export { thisisacluborassociation5 as "thisIsAClubOrAssociation" }